/*
 * Copyright (c) 2019-present Sonatype, Inc.
 * This program and the accompanying materials are made available under
 * the terms of the Eclipse Public License 2.0 which accompanies this
 * distribution and is available at https://www.eclipse.org/legal/epl-2.0/.
 */
/* eslint react/prop-types: 0 */
import React from 'react';
import DetailLink from './DetailLink';
import RenderDetail from './RenderDetail';
var WeaknessDetail = function WeaknessDetail(_a) {
    var weakness = _a.weakness;
    if (weakness) {
        var cweLinks = weakness.cweIds.map(function (cweId) {
            return React.createElement("dd", { key: cweId.id },
                React.createElement(DetailLink, { href: cweId.uri }, cweId.id));
        });
        return cweLinks.length ? (React.createElement(RenderDetail, { title: "Weakness" },
            React.createElement("dl", null,
                React.createElement("dt", null,
                    weakness.cweSource,
                    " CWE:"),
                cweLinks))) : null;
    }
    else {
        return null;
    }
};
export default WeaknessDetail;
//# sourceMappingURL=WeaknessDetail.js.map